import styled from 'styled-components';

const StyledCategorySection = styled.div`
  color: ${(props): string => props.theme.colors.pureWhite};
  width: 100%;
  user-select: none;
`;

export default StyledCategorySection;
